import React from 'react'
import { connect } from 'react-redux'
import { getIsMobileDevice, getIsTransitioning } from 'SRC/modules/common/selectors'
import Link from 'next/link'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'

import translations from '../../../../../../public/data/translations.json'

const PartsItem = ({
  id,
  icon,
  title,
  isMobileDevice,
  isTransitioning
}) => {
  const { lang } = useTranslation('common')
  const router = useRouter()

  const locale = lang?.toUpperCase() || 'ME'

  const flexGrow = 3

  const isActive = ['/vehicleParts', '/vehiclePartsSearch'].includes(router?.pathname)

  if (!isTransitioning || isActive) {
    return (
      <div
        className={`kategorije-item ${isActive ? 'active' : ''}`}
        style={!isMobileDevice ? { flexGrow } : {}}
      >
        <Link
          href={{
            pathname: '/vehicleParts',
            query: {
              group: translations['auto-djelovi'][locale].gume.slug, locale: lang
            }
          }}
          as={`/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`}
        >
          <a>
            <div className='kategorije-item-icon'>
              <ReactSVG src='https://slike.autodiler.me/shop/gume.svg' beforeInjection={svg => {
                svg.setAttribute('style', 'width: 45px; height: 45px;')
              }} className='kategorije-item-icon__parts' />
            </div>
            <div className='kategorije-item-text'>
              <p>{translations['auto-djelovi'][locale].gume.title}</p>
            </div>
          </a>
        </Link>
      </div>
    )
  }

  return (
    <div
      className={`kategorije-item disabled`}
      style={!isMobileDevice ? { flexGrow } : {}}
    >
      <a href='javascript:void(0)' style={{ opacity: .4, cursor: 'not-allowed' }}>
        <div className='kategorije-item-icon'>
          <img className='kategorije-item-icon__parts' src='https://slike.autodiler.me/shop/gume.svg' alt='Nove gume' />
        </div>
        <div className='kategorije-item-text'>
          <p>{translations['auto-djelovi'][locale].gume.title}</p>
        </div>
      </a>
    </div>
  )
}

const mapStateToProps = state => ({
  isMobileDevice: getIsMobileDevice(state),
  isTransitioning: getIsTransitioning(state)
})

PartsItem.propTypes = {
  isMobileDevice: PropTypes.bool.isRequired,
  isTransitioning: PropTypes.bool.isRequired
}

export default connect(mapStateToProps)(PartsItem)
